import './App.css';
import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalNav from './components/global-nav/global-nav';
import MusicPlayer from './components/audio-player/audio-player';
import Home from './components/home/home';
import Artist from './components/artist/artist';
import Artists from './components/artists/artists';
import Track from './components/track/track';
import Tracks from './components/tracks/tracks';
import VocalMenu from './components/vocal-menu/vocal-menu';

import { ThemeProvider } from '@mui/material/styles';
import { lightTheme, darkTheme, testTheme, injectThemeToCSS } from './config/theme';
import Login from './components/login/login';
// import InitialLogin from './components/initial-login/initial-login';
import SignUp from './components/signup/signup';
import VoxAuthDialog from './components/vox-auth-dialog/vox-auth-dialog';
import Menu from './components/menu/menu';
import Modal from './components/modal/modal';
import { ToastContainer, Slide  } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const App = () => {
  // const [isAuthenticated, setIsAuthenticated] = useState(false);
  const selectedTheme = useSelector((state) => state.selectedTheme.theme);
  const loginVisible = useSelector((state) => state.dialogControl.loginVisible);
  const signupVisible = useSelector((state) => state.dialogControl.signupVisible);
  const voxAuthDialogVisible = useSelector((state) => state.dialogControl.voxAuthDialogVisible);
  const menuVisible = useSelector((state) => state.dialogControl.menuVisible);
  const modal = useSelector((state) => state.dialogControl.modal);
  
  let theme;
  switch(selectedTheme) {
    case 'light':
      theme = lightTheme;
      break;
    case 'dark':
      theme = darkTheme;
      break;
    case 'test':
        theme = testTheme;
        break;
    default:
      theme = lightTheme;
      break;
  }
  injectThemeToCSS(theme);

  // TODO: replace this with real auth
  // useEffect(() => {
  //   const auth = localStorage.getItem('authenticated');
  //   setIsAuthenticated(auth === 'true');
  // }, []);

  // const handleLogin = () => {
  //   setIsAuthenticated(true); // Set authenticated state
  // };


  return (
    <ThemeProvider theme={theme}>
      {/* { isAuthenticated ? */}
        <Router>
        <div className="app-container">
          { !loginVisible && !signupVisible && (
            <div className='navbar'>
              <GlobalNav />
            </div>
          )}
          <div className='app-content'>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/artists" element={<Artists />} />
              <Route path="/artist/:id" element={<Artist />} />
              <Route path="/tracks" element={<Tracks />} />
              <Route path="/track/:id" element={<Track />} />
              <Route path="/voice" element={<VocalMenu />} />
            </Routes>
          </div>
          <MusicPlayer />
          <ToastContainer 
            transition={Slide} 
            position="top-center" 
            autoClose={3000} 
            theme='dark'
          />
        </div>
        {loginVisible && 
          <Login />
        }
        {signupVisible && 
          <SignUp />
        }
        {menuVisible && 
            <Menu />
        }
        {voxAuthDialogVisible && 
          <VoxAuthDialog />
        }
        {modal && modal.visible &&
            <Modal />
        }
      </Router>
      
      {/* //   :
       
      //  <InitialLogin onLogin={handleLogin} />

      // } */}
      
    </ThemeProvider>
  );
}

export default App;
